<template>
	<div id="image-container">
		<vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>

		<!-- modo arrastar -->
		<div v-if="isDrag">
			<a class="btn btn-primary" href="#" @click.prevent="getComponentData" v-if="isButton">>Gravar Ordenação</a>
			<draggable
				:list="files"
				group="people"
				@start="drag = true"
				@end="drag = false"
				@change="log"
				class="mb-8 mx-auto flex flex-wrap justify-content-start-ml-3 h-auto"
			>
				<div
					v-for="(item, index) in files"
					:key="index"
					class="image-card"
				>
					<div class="relative flex flex-col items-center justify-start">
						<div
							class="absolute top-2 left-2 flex items-center justify-center bg-white bg-opacity-90 rounded-full p-1 shadow"
							:class="(item.status == 'uploaded') && 'hidden'"
						>
							<i
								@click="destroy(item[id], item.url, index)"
								title="Apagar"
								class="transition-colors	duration-700 cursor-pointer hover:text-red-400 fa fa-trash text-gray-500 text-xs"
							></i>
						</div>

						<div class="number absolute top-1 right-1">{{ index + 1 }}</div>

						<div v-if="!isFile">
							<div v-if="capa" class="capa" @click.prevent="getSelect(item)">
								<img class="upload-images object-cover rounded-md" :src="item.images" />
								<div :class="{ select: item.capa }">Capa</div>
							</div>
							<img v-else class="upload-images object-cover rounded-md" :src="item.images" />
						</div>
						<div v-else>
							<img class="upload-images object-cover rounded-md" src="./art/file.png" />
						</div>
					</div>

					<div class="radio-mobile">
						<label class="flex flex-col items-center justify-center cursor-pointer text-sm text-gray-700">
							<input
								type="radio"
								name="capaRadio"
								class="accent-[#438eb9] w-7 h-7"
								:checked="item.capa"
								@click.prevent="getSelect(item)"
							/>
							<span :class="{ 'text-[#438eb9] font-semibold': item.capa }">Capa</span>
						</label>
					</div>
				</div>
			</draggable>
		</div>

		<div v-else class="mb-8 mx-auto flex flex-wrap justify-content-start-ml-3 h-auto">
			<div
				v-for="(item, index) in files"
				:key="index"
				class="image-card"
			>
				<div class="relative flex flex-col items-center justify-start">
					<div
						class="absolute top-2 left-2 flex items-center justify-center bg-white bg-opacity-90 rounded-full p-1 shadow"
						:class="(item.status == 'uploaded') && 'hidden'"
					>
						<i
							@click="destroy(item[id], item.url, index)"
							title="Apagar"
							class="transition-colors	duration-700 cursor-pointer hover:text-red-400 fa fa-trash text-gray-500 text-xs"
						></i>
					</div>

					<div class="number absolute top-1 right-1">{{ index + 1 }}</div>

					<div v-if="!isFile">
						<div v-if="capa" class="capa" @click.prevent="getSelect(item)">
							<img class="upload-images object-cover rounded-md" :src="item.images" />
							<div :class="{ select: item.capa }">Capa</div>
						</div>
						<img v-else class="upload-images object-cover rounded-md" :src="item.images" />
					</div>
					<div v-else>
						<img class="upload-images object-cover rounded-md" src="./art/file.png" />
					</div>
				</div>

				<div class="radio-mobile">
					<label class="flex flex-col items-center justify-center cursor-pointer text-sm text-gray-700">
						<input
							type="radio"
							name="capaRadio"
							class="accent-[#438eb9] w-7 h-7"
							:checked="item.capa"
							@click.prevent="getSelect(item)"
						/>
						<span :class="{ 'text-[#438eb9] font-semibold': item.capa }">Capa</span>
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import draggable from 'vuedraggable'
import { confirme } from '@/components/Message'

export default {
	props: {
		url: { type: String, default: '/' },
		files: {},
		capa: {},
		id: {},
		isFile: { type: Boolean, default: false },
		isDrag: { type: Boolean, default: false },
		isButton: { type: Boolean, default: false },
		urlSort: { type: String, default: '/' },
		idSort: {}
	},
	components: { VueElementLoading, draggable },
	data: () => ({ isActive: false }),
	methods: {
		log() {
			if (!this.isButton) this.getComponentData()
		},
		async getComponentData() {
			this.isActive = true
			await Promise.all(this.files.map(async (ex, ek) => {
				await axios.put(`${this.urlSort}${ex[this.idSort]}`, { order: ek }).catch(() => {
					this.isActive = false
				})
				return ex
			}))
			this.isActive = false
		},
		async destroy(id, file, index) {
			const result = await confirme(
				'Atenção',
				'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados'
			)
			if (result.value) {
				this.isActive = true
				await axios.delete(`${this.url}/${id}`).catch(() => { })
				URL.revokeObjectURL(file)
				this.files.splice(index, 1)
				this.isActive = false
			}
		},
		cancelUpload(index) {
			this.items[index].source.cancel()
			this.items[index].status = 'cancel'
			if (!this.$parent.isAllUploading()) this.$parent.$data.uploading = false
		},
		isAllNullExceptOne() {
			let result = this.files.reduce((total, cur) => Number(Boolean(cur)) + total)
			return result == 1
		},
		async getSelect(item) {
			await this.files.map(i => { i.capa = null; return i })
			await axios.put(`${this.url}/${item[this.id]}`, item).catch(() => { })
			item.capa = 1
		},
		startPress(item) {
			this.pressTimer = setTimeout(() => {
				this.getSelect(item)
			}, 600)
		},
		cancelPress() {
			clearTimeout(this.pressTimer)
		}
	}
}
</script>

<style lang="scss" scoped>
.image-card {
	width: 100px;
	height: auto;
	margin: 0.75rem;
	border: 2px solid #e5e7eb;
	border-radius: 0.5rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #fff;
	padding-bottom: 0.5rem;
}

.upload-images {
	width: 100px;
	height: 100px;
	border-radius: 0.25rem;
}

.radio-mobile {
	display: none;
}

@media (max-width: 640px) {
	.image-card {
		width: 120px;
		padding-bottom: 0.75rem;
	}

	.upload-images {
		width: 120px;
		height: 120px;
	}

	.radio-mobile {
		display: flex !important;
		margin-top: 0.5rem;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
}

.capa {
	cursor: pointer;
}
.select {
	position: absolute;
	bottom: 5px;
	width: 100%;
	background: #438eb9;
	display: flex;
	justify-content: center;
	color: #fff;
}
.drag {
	border: 1px dashed #ccc;
	padding: 5px;
}
.number {
	background-color: #438eb9;
	border-radius: 50%;
	height: 24px;
	width: 24px;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: bold;
}
</style>
